import { Email, Instagram, LocalPhone } from "@mui/icons-material";
import { Div, Text, Title } from "view/lib/components";
import Button from "view/lib/components/button";

enum ContactType {
  Contact,
  SocialMedia
}

const contactDetails = [{
    icon: <LocalPhone />,
    text: "+91 9545911679",
    link: "tel",
    type: ContactType.Contact
  }, {
    icon: <LocalPhone />,
    text: "+1 (825) 993-9306",
    link: "tel",
    type: ContactType.Contact
  }, {
    icon: <Email />,
    text: "ruturaj.gole813@gmail.com",
    link: "mailto:",
    type: ContactType.Contact
  }, {
    icon: <Email />,
    text: "ruturaj@ualberta.ca",
    link: "mailto:",
    type: ContactType.Contact
  }, {
    icon: <Instagram />,
    text: "Instagram",
    link: "https://www.instagram.com/ruturajwendigo/",
    type: ContactType.SocialMedia
  }
];

interface Props {
  readonly data: Record<string, string>;
}

const Contact = ({ data }: Props) =>
  <Div style={styles.container}>
    <Title title="Contact" />
    <Text>For any inquiries, please refer to the contact details below.</Text>
    <Div style={styles.contactsContainer}>
      {contactDetails.map((contact) =>
        <Div key={contact.text} style={styles.contact}>
          {contact.icon}
          <Button
            style={styles.contactText}
            onClick={() => {}}
            props={{
              component: "a",
              href: `${contact.link}${(contact.type === ContactType.Contact ? contact.text : "") }`
            }}>
            {contact.text}
          </Button>
        </Div>
      )}
  </Div>
  </Div>;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    padding: "2%"
  },
  contactsContainer: {
    marginTop: "1%"
  },
  contact: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "max-content",
    whiteSpace: "nowrap"
  },
  contactText: {
    fontWeight: "bolder",
    marginLeft: "2%",
    width: "100%"
  }
}

export default Contact;